module.exports = __webpack_public_path__ + "img/mf.5b9ff36c.svg";